'use client'

import { useLocale } from 'next-intl'
import { useState } from 'react'
import { Button } from '@/components/button'
import { EnglishUserTermsAndConditions } from '@/features/terms-and-conditions/english-user-terms-and-conditions'
import { GermanUserTermsAndConditions } from '@/features/terms-and-conditions/german-user-terms-and-conditions'
import { Language, parseLanguageFromLocale } from '@/setup/locales'
import { run } from '@/utils/run'

export function UserTermsAndConditionsContent() {
    const locale = useLocale()

    const currentLanguage = parseLanguageFromLocale(locale)

    const [selectedVersion, setSelectedVersion] = useState(2)

    return (
        <div className="flex flex-col w-full items-center justify-center">
            <div className="flex gap-2 mt-8">
                <Button
                    onClick={() => setSelectedVersion(2)}
                    styleType={selectedVersion === 2 ? 'primary' : 'secondary'}
                >
                    22.04.2026
                </Button>

                <Button
                    onClick={() => setSelectedVersion(1)}
                    styleType={selectedVersion === 1 ? 'primary' : 'secondary'}
                >
                    03.03.2026
                </Button>

                <Button
                    onClick={() => setSelectedVersion(0)}
                    styleType={selectedVersion === 0 ? 'primary' : 'secondary'}
                >
                    01.11.2025
                </Button>
            </div>

            {run(() => {
                switch (currentLanguage) {
                    case Language.DE:
                        return <GermanUserTermsAndConditions version={selectedVersion} />

                    default:
                        return <EnglishUserTermsAndConditions version={selectedVersion} />
                }
            })}
        </div>
    )
}
